export const SET_AUTH_PROPERTY = 'SET_AUTH_PROPERTY';
export const RECOVERY_PASSWORD = 'RECOVERY_PASSWORD';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const NEW_DRIVER = 'NEW_DRIVER';
export const CONFIRM_NEW_DRIVER = 'CONFIRM_NEW_DRIVER';

export const POST_LOGIN_IDENTITY = 'POST_LOGIN_IDENTITY';
export const SET_USER_INFO = 'SET_USER_INFO';
export const GET_LOGOUT = 'GET_LOGOUT';
export const RESTORE_SESSION = 'RESTORE_SESSION';
export const POST_USER_SESSION = 'POST_USER_SESSION';
export const GET_USER_INFO = 'GET_USER_INFO';
